<template>
  <div>
    <h2 :class="['headline', 'font-grey', 'font-l-600']" v-html="title" />
    <div :class="['server-side-description']" v-html="description" />
    <example-title src="example-1.html" title="Demo" />
    <div :style="{width: width}" :class="['elevation-5']">
      <vc-toolbar narrow>
        <vc-toolbar-icon-left icon="menu" />
        <vc-toolbar-title>My Chat App</vc-toolbar-title>
        <vc-toolbar-controls-right>
          <vc-button color="primary" icon-button>
            <vc-icon>account_circle</vc-icon>
          </vc-button>
        </vc-toolbar-controls-right>
      </vc-toolbar>
      <vc-chat
        @update="autoRespond($event)"
        :height="height"
        :width="width"
        :transcript="transcript" />
      <form @submit.prevent="submit" :class="['pa-16']">
        <vc-text
          autofocus
          placeholder="Type something and hit enter"
          color="primary"
          icon-left="chat"
          type="text"
          v-model="chat"
          name="chatbox" />
      </form>
    </div>
    <example-title src="transcript.json" title="The :transcript object" />
    <p>Click the "get code" button to the right to see a typical <code>transcript</code> object for the component.</p>
    <api-grid ref="api-grid" />
  </div>
</template>
<script>
import methods from '../helpers/methods'
import transcript from '../../static/examples/components/chat/transcript'

export default {
  name: 'ChatPage',
  mixins: [
    methods
  ],
  data () {
    return {
      chat: null,
      title: null,
      description: null,
      width: 'auto',
      height: '300px',
      responses: [
        'Lorem ipsum dolor sit amet, consectetur adipiscing elit',
        'Sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt.',
        'Neque porro dolorem eum fugiat quo voluptas nulla pariatur?',
        'At vero eos quo minus id quod maxime placeat facere possimus, omnis voluptas',
        'Temporibus aut perferendis doloribus asperiores repellat.',
        'Duis aute irure dolor deserunt mollit anim id est laborum.',
        'Ut enim ad  nulla pariatur?',
        'Et harum quidem sint et molestiae non recusandae.',
        'Itaque earum rerum.'
      ],
      transcript: transcript
    }
  },
  mounted () {
    this.getPage()
  },
  methods: {
    autoRespond (data) {
      if (data.me) {
        const date = new Date()
        const responses = this.responses
        setTimeout(() => {
          this.transcript.items.push({
            name: 'John',
            timestamp: date.getTime(),
            body: `You typed "${data.body}". ${responses[Math.floor(Math.random() * responses.length)]}`,
            avatar: '/static/images/avatar-01.png',
            color: 'yellow'
          })
        }, 2000)
      }
    },
    submit () {
      const date = new Date()
      this.transcript.items.push({
        name: 'Martin',
        timestamp: date.getTime(),
        body: this.chat,
        me: true,
        avatar: '/static/images/avatar-01.png',
        color: 'primary'
      })
      this.chat = null
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/chat.vue